<template>
  <div class="wlx-stu-manager-wrapper">
    <div class="u-school-manager-head stu-manager-head-con clearfix">
      <!-- <router-link :to="{name:'teaBookList'}" class="head-link-a">教材管理</router-link>
      <router-link :to="{name:'videoList'}" class="head-link-a">串讲视频管理</router-link> -->
    </div>
    <div class="u-table-main">
      <router-view></router-view>
    </div>
  </div>   
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.wlx-stu-manager-wrapper {
  .stu-manager-head-con {
    text-align: left;
    .head-link-a {
      float: left;
      padding: 0 20px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      color: #000;
    }
    .head-link-a:hover {
      color: #409eff;
    }
    .linkActive {
      border-bottom: 2px solid #409eff;
      color: #409eff;
    }
  }
}
</style>
